const imageUrls = {
    "beasts": [
        {
            "name": "Z-01 (P-ZED)",
            "gif": "QmQCCTKPMfmk5BDYk1BpTo2hqMBeS5M1prUSGk5nWctG2j",
            "jpg": "QmQCCTKPMfmk5BDYk1BpTo2hqMBeS5M1prUSGk5nWctG2j"
        }, {
            "name": "P-14 (W-RIF)",
            "gif": "QmZKhAfr8BYURZBhJya1tpcYoj6Zr3Cp1Ak42CnTBHk59t",
            "jpg": "QmZKhAfr8BYURZBhJya1tpcYoj6Zr3Cp1Ak42CnTBHk59t"
        }, {
            "name": "T-93 (X-VIL)",
            "gif": "QmVPvFFEht9xKRXbyRTF5xmBe4SiNviwmArz6QRdUXZkkD",
            "jpg": "QmVPvFFEht9xKRXbyRTF5xmBe4SiNviwmArz6QRdUXZkkD"
        }, {
            "name": "Destroyer",
            "gif": "QmfEWqV6SJnwYKnM7dH1FL3WHm1qHaSnkwf7UaGWkrJ2FW",
            "jpg": "QmfEWqV6SJnwYKnM7dH1FL3WHm1qHaSnkwf7UaGWkrJ2FW"
        }, {
            "name": "Imperial Destroyer",
            "gif": "QmT4buvcrYY5U39mLqDLEWNZ1gmoQRpurkvQTy8UEW5ycS",
            "jpg": "QmT4buvcrYY5U39mLqDLEWNZ1gmoQRpurkvQTy8UEW5ycS"
        }, {
            "name": "Intergalactic Destroyer",
            "gif": "Qme11M3unKPaWyCzNz46Ff4XGhVs2eqWsAQW96mnWrYHWg",
            "jpg": "Qme11M3unKPaWyCzNz46Ff4XGhVs2eqWsAQW96mnWrYHWg"
        }
    ],
    "warriors": [
        {
            "name": "soldier warrior",
            "gif": "QmNrQpv7acpiKWk1KjN9kL93e6FVA9sWAzWQLNLVDw3miG",
            "jpg": "QmNrQpv7acpiKWk1KjN9kL93e6FVA9sWAzWQLNLVDw3miG" 
        },
        {
            "name": "First sergeant",
            "gif": "QmRrgkNSP1dkYYNKcMXooajNEfzoCJr9r63pgtCR3DwXjp",
            "jpg": "QmRrgkNSP1dkYYNKcMXooajNEfzoCJr9r63pgtCR3DwXjp" 
        },
        {
            "name": "senior petty officer",
            "gif": "QmXt8d5hvEF6m7vtRXdPXY9nHPykffV3kjYgUDbKyDPWcC",
            "jpg": "QmXt8d5hvEF6m7vtRXdPXY9nHPykffV3kjYgUDbKyDPWcC" 
        },
        {
            "name": "adjutor officer",
            "gif": "QmUKPVsy5UXzXf6iQxc98qaR3ZEsXCQUcSSsrwmXkxauS6",
            "jpg": "QmUKPVsy5UXzXf6iQxc98qaR3ZEsXCQUcSSsrwmXkxauS6"
        },
        {
            "name": "imperial deputy commander",
            "gif": "QmS2xVmRTHVinwBikBrgHZ8zoA68HfYJ4AhhfkmQmKxG4P",
            "jpg": "QmS2xVmRTHVinwBikBrgHZ8zoA68HfYJ4AhhfkmQmKxG4P"
        },
        {
            "name": "imperial commanding general",
            "gif": "QmXwaSwxe2nhU3G7AMrHmtqqgeBRe4czK3GiWzm5LhzMjz",
            "jpg": "QmXwaSwxe2nhU3G7AMrHmtqqgeBRe4czK3GiWzm5LhzMjz"
        }
    ],
    "monsters": [
        {
            "name": "Dark Fury",
            "gif": "QmUkSAmbRUpcE1MYcURgVGBrq8HRDMEX5qYDJCMCoNZxKq",
            "jpg": "QmUkSAmbRUpcE1MYcURgVGBrq8HRDMEX5qYDJCMCoNZxKq",
            "dead_jpg": "QmUkSAmbRUpcE1MYcURgVGBrq8HRDMEX5qYDJCMCoNZxKq",
            "dead_gif": "QmUkSAmbRUpcE1MYcURgVGBrq8HRDMEX5qYDJCMCoNZxKq"
        }, {
            "name": "Aqua",
            "gif": "QmajUQVPh9zgEFvXoYmv1HvZVF5WxurNu76gxeWuSH6r4S",
            "jpg": "QmajUQVPh9zgEFvXoYmv1HvZVF5WxurNu76gxeWuSH6r4S",
            "dead_jpg": "QmajUQVPh9zgEFvXoYmv1HvZVF5WxurNu76gxeWuSH6r4S",
            "dead_gif": "QmajUQVPh9zgEFvXoYmv1HvZVF5WxurNu76gxeWuSH6r4S"
        }, {
            "name": "Onixtum",
            "gif": "QmVK1b8xx8jmYDwGieuStMMSu7F3jUjorxcnCAPgHBpiAY",
            "jpg": "QmVK1b8xx8jmYDwGieuStMMSu7F3jUjorxcnCAPgHBpiAY",
            "dead_jpg": "QmVK1b8xx8jmYDwGieuStMMSu7F3jUjorxcnCAPgHBpiAY",
            "dead_gif": "QmVK1b8xx8jmYDwGieuStMMSu7F3jUjorxcnCAPgHBpiAY"
        }, {
            "name": "Aliumi",
            "gif": "QmcMYMTaf2j4fQ8Cyez4wjWkzA9YhKXQ6eTi8no6X39oTx",
            "jpg": "QmcMYMTaf2j4fQ8Cyez4wjWkzA9YhKXQ6eTi8no6X39oTx",
            "dead_jpg": "QmcMYMTaf2j4fQ8Cyez4wjWkzA9YhKXQ6eTi8no6X39oTx",
            "dead_gif": "QmcMYMTaf2j4fQ8Cyez4wjWkzA9YhKXQ6eTi8no6X39oTx" 
        }, {
            "name": "T-rex 524",
            "gif": "QmTRUKDiVd8m2HneiDxrugPNCBEZfxKVVWUnq8Ypkyyqr2",
            "jpg": "QmTRUKDiVd8m2HneiDxrugPNCBEZfxKVVWUnq8Ypkyyqr2",
            "dead_jpg": "QmTRUKDiVd8m2HneiDxrugPNCBEZfxKVVWUnq8Ypkyyqr2",
            "dead_gif": "QmTRUKDiVd8m2HneiDxrugPNCBEZfxKVVWUnq8Ypkyyqr2"
        }, {
            "name": "Viltrum",
            "gif": "QmdWmmPWHNsYg45JHcBqQB4DSuq6jqWB3ssBvQZ7f5wh9P",
            "jpg": "QmdWmmPWHNsYg45JHcBqQB4DSuq6jqWB3ssBvQZ7f5wh9P",
            "dead_jpg": "QmdWmmPWHNsYg45JHcBqQB4DSuq6jqWB3ssBvQZ7f5wh9P",
            "dead_gif": "QmdWmmPWHNsYg45JHcBqQB4DSuq6jqWB3ssBvQZ7f5wh9P" 
        }, {
            "name": "Valarium",
            "gif": "QmQVkkhNmw1Chksx3zPajuV5BEZqqnabsXmouhLeEdbq2K", 
            "jpg": "QmQVkkhNmw1Chksx3zPajuV5BEZqqnabsXmouhLeEdbq2K",
            "dead_jpg": "QmQVkkhNmw1Chksx3zPajuV5BEZqqnabsXmouhLeEdbq2K",
            "dead_gif": "QmQVkkhNmw1Chksx3zPajuV5BEZqqnabsXmouhLeEdbq2K"

        }, {
            "name": "Gaintox",
            "gif": "QmQMgY3uVBriTTdTAqTJbeFCopezVbP4Lqm9GpEWT1MxDP",
            "jpg": "QmQMgY3uVBriTTdTAqTJbeFCopezVbP4Lqm9GpEWT1MxDP",
            "dead_jpg": "QmQMgY3uVBriTTdTAqTJbeFCopezVbP4Lqm9GpEWT1MxDP",
            "dead_gif": "QmQMgY3uVBriTTdTAqTJbeFCopezVbP4Lqm9GpEWT1MxDP"
        }, {
            "name": "Forest",
            "gif": "QmeHgGCy8WmpXUyFugpxTamACwuV8Q3zyNnKTz8SVeuSXt",
            "jpg": "QmeHgGCy8WmpXUyFugpxTamACwuV8Q3zyNnKTz8SVeuSXt",
            "dead_jpg": "QmeHgGCy8WmpXUyFugpxTamACwuV8Q3zyNnKTz8SVeuSXt",
            "dead_gif": "QmeHgGCy8WmpXUyFugpxTamACwuV8Q3zyNnKTz8SVeuSXt"
        }, {
            "name": "ice",
            "gif": "QmUN3hmiLwyXeUBALHfhT9nwk2ZPCm3PsA7p8dG2BeV1aP",
            "jpg": "QmUN3hmiLwyXeUBALHfhT9nwk2ZPCm3PsA7p8dG2BeV1aP",
            "dead_jpg": "QmUN3hmiLwyXeUBALHfhT9nwk2ZPCm3PsA7p8dG2BeV1aP",
            "dead_gif": "QmUN3hmiLwyXeUBALHfhT9nwk2ZPCm3PsA7p8dG2BeV1aP"
        }, {
            "name": "PlanetOrc",
            "gif": "QmNTqavCphzB7Tq9gp3Cbq9rquJ7mrdM1CjtHjiZTVmrNW",
            "jpg": "QmNTqavCphzB7Tq9gp3Cbq9rquJ7mrdM1CjtHjiZTVmrNW",
            "dead_jpg": "QmNTqavCphzB7Tq9gp3Cbq9rquJ7mrdM1CjtHjiZTVmrNW",
            "dead_gif": "QmNTqavCphzB7Tq9gp3Cbq9rquJ7mrdM1CjtHjiZTVmrNW"
        }, {
            "name": "Dragonia",
            "gif": "QmNbcUvuuhfjY7bLTmrdBvMqa6K3HFJW32UyLYHz66XYAd",
            "jpg": "QmNbcUvuuhfjY7bLTmrdBvMqa6K3HFJW32UyLYHz66XYAd",
            "dead_jpg": "QmNbcUvuuhfjY7bLTmrdBvMqa6K3HFJW32UyLYHz66XYAd",
            "dead_gif": "QmNbcUvuuhfjY7bLTmrdBvMqa6K3HFJW32UyLYHz66XYAd"
        }, {
            "name": "Chimura",
            "gif": "QmQGJVo5koZvaNXgW4FrSgJVhPci5Jyq3XaQu9Bou3hKkH",
            "jpg": "QmQGJVo5koZvaNXgW4FrSgJVhPci5Jyq3XaQu9Bou3hKkH",
            "dead_jpg": "QmQGJVo5koZvaNXgW4FrSgJVhPci5Jyq3XaQu9Bou3hKkH",
            "dead_gif": "QmQGJVo5koZvaNXgW4FrSgJVhPci5Jyq3XaQu9Bou3hKkH"
        }, {
            "name": "Predator",
            "gif": "QmacxDGSDPg1qN6SkXUed5K3Z3pdGGhDzv465ChiKfndG4",
            "jpg": "QmacxDGSDPg1qN6SkXUed5K3Z3pdGGhDzv465ChiKfndG4",
            "dead_jpg": "QmacxDGSDPg1qN6SkXUed5K3Z3pdGGhDzv465ChiKfndG4",
            "dead_gif": "QmacxDGSDPg1qN6SkXUed5K3Z3pdGGhDzv465ChiKfndG4"
        }, {
            "name": "Ingernus",
            "gif": "QmQ1kFyU6xwDsedYaJuPTK6ybcJRcRak956J1RGcE3LZ8o",
            "jpg": "QmQ1kFyU6xwDsedYaJuPTK6ybcJRcRak956J1RGcE3LZ8o",
            "dead_jpg": "QmQ1kFyU6xwDsedYaJuPTK6ybcJRcRak956J1RGcE3LZ8o",
            "dead_gif": "QmQ1kFyU6xwDsedYaJuPTK6ybcJRcRak956J1RGcE3LZ8o"
        }, {
            "name": "raquiron",
            "gif": "QmVzHhjPBbu9yrrhH9P9yzyV7VVnjZW3zZ5ZeTq5aiVDTy",
            "jpg": "QmVzHhjPBbu9yrrhH9P9yzyV7VVnjZW3zZ5ZeTq5aiVDTy",
            "dead_jpg": "QmVzHhjPBbu9yrrhH9P9yzyV7VVnjZW3zZ5ZeTq5aiVDTy",
            "dead_gif": "QmVzHhjPBbu9yrrhH9P9yzyV7VVnjZW3zZ5ZeTq5aiVDTy"


        }, {
            "name": "ceberus",
            "gif": "QmakWZncTfFmntv3ArfCjnWk2siG8eX3qKZdijDwXzN3cr",
            "jpg": "QmakWZncTfFmntv3ArfCjnWk2siG8eX3qKZdijDwXzN3cr",
            "dead_jpg": "QmakWZncTfFmntv3ArfCjnWk2siG8eX3qKZdijDwXzN3cr",
            "dead_gif": "QmakWZncTfFmntv3ArfCjnWk2siG8eX3qKZdijDwXzN3cr"
        }, {
            "name": "tipax",
            "gif": "QmQtbbNRVHiApEtnmDm31QUtFJeJzt4nZz9MogPF15rM89",
            "jpg": "QmQtbbNRVHiApEtnmDm31QUtFJeJzt4nZz9MogPF15rM89",
            "dead_jpg": "QmQtbbNRVHiApEtnmDm31QUtFJeJzt4nZz9MogPF15rM89",
            "dead_gif": "QmQtbbNRVHiApEtnmDm31QUtFJeJzt4nZz9MogPF15rM89"
        }, {
            "name": "Camaliumi",
            "gif": "QmXHuUXHrrkxnjgVFh3ZQgodKPfxwVDf7rfhhyVqsdxLNx",
            "jpg": "QmXHuUXHrrkxnjgVFh3ZQgodKPfxwVDf7rfhhyVqsdxLNx",
            "dead_jpg": "QmXHuUXHrrkxnjgVFh3ZQgodKPfxwVDf7rfhhyVqsdxLNx",
            "dead_gif": "QmXHuUXHrrkxnjgVFh3ZQgodKPfxwVDf7rfhhyVqsdxLNx"
        }, {
            "name": "Cyborgrium",
            "gif": "QmSiYiVfHiZzfyjByZSBbwfbHVaf9pquoQYVe1V6YA5d9A",
            "jpg": "QmSiYiVfHiZzfyjByZSBbwfbHVaf9pquoQYVe1V6YA5d9A",
            "dead_jpg": "QmSiYiVfHiZzfyjByZSBbwfbHVaf9pquoQYVe1V6YA5d9A",
            "dead_gif": "QmSiYiVfHiZzfyjByZSBbwfbHVaf9pquoQYVe1V6YA5d9A"
        }, {
            "name": "undead",
            "gif": "QmNVQq2KFY8SjFSVjenSXFqJY7WEVmku6VUDZSdFguMEga",
            "jpg": "QmNVQq2KFY8SjFSVjenSXFqJY7WEVmku6VUDZSdFguMEga",
            "dead_jpg": "QmNVQq2KFY8SjFSVjenSXFqJY7WEVmku6VUDZSdFguMEga",
            "dead_gif": "QmNVQq2KFY8SjFSVjenSXFqJY7WEVmku6VUDZSdFguMEga"
        }, {
            "name": "elemental",
            "gif": "QmQPBmPrB2wwDSs7ffj6kf2vaXo2UGFPADeQbi9YxKaWYa",
            "jpg": "QmQPBmPrB2wwDSs7ffj6kf2vaXo2UGFPADeQbi9YxKaWYa",
            "dead_jpg": "QmQPBmPrB2wwDSs7ffj6kf2vaXo2UGFPADeQbi9YxKaWYa",
            "dead_gif": "QmQPBmPrB2wwDSs7ffj6kf2vaXo2UGFPADeQbi9YxKaWYa"
        }, {
            "name": "Reptilian",
            "gif": "QmY3JKkXSr2CNh78MyXU5MWnZrSR2pFHyyA53ooPF3iV1x",
            "jpg": "QmY3JKkXSr2CNh78MyXU5MWnZrSR2pFHyyA53ooPF3iV1x",
            "dead_jpg": "QmY3JKkXSr2CNh78MyXU5MWnZrSR2pFHyyA53ooPF3iV1x",
            "dead_gif": "QmY3JKkXSr2CNh78MyXU5MWnZrSR2pFHyyA53ooPF3iV1x"
        }, {
            "name": "Anunakki",
            "gif": "QmRMNLffM43mbfFjASLfiQgrN2iWsoxDPCUXwBb3fYaFgx",
            "jpg": "QmRMNLffM43mbfFjASLfiQgrN2iWsoxDPCUXwBb3fYaFgx",
            "dead_jpg": "QmRMNLffM43mbfFjASLfiQgrN2iWsoxDPCUXwBb3fYaFgx",
            "dead_gif": "QmRMNLffM43mbfFjASLfiQgrN2iWsoxDPCUXwBb3fYaFgx"
        }
    ],
    baseUrl: "https://gateway.pinata.cloud/ipfs/",
};
export default imageUrls;
